import React, { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import * as XLSX from 'xlsx';
import { GET_USER_DETAILS_XLS } from '../../../../graphql/Query/users';
import { MdOutlineDownload } from 'react-icons/md';
import { Button } from 'reactstrap';

const ExportToXLSXButton = ({ userId }) => {
  const [
    fetchUserDetails,
    {
      data: userDetailsData,
      loading: userDetailsLoading,
      error: userDetailsError
    }
  ] = useLazyQuery(GET_USER_DETAILS_XLS, {
    variables: { input: { userId } },
    fetchPolicy: 'no-cache'
  });

  const generateSingleRowArray = (userData) => {
    const {
      fullName,
      email,
      phonecode,
      membership,
      createdAt,
      gender,
      country,
      phone,
      status,
      referralCode,
      usedReferralCode,
      timezone,
      expoToken,
      platform,
      disable,
      pillars,
      emotions,
      roadshistory
    } = userData;

    const profileData = [
      fullName,
      email,
      phone,
      phonecode,
      country,
      gender,
      new Date(createdAt).toLocaleString(),
      referralCode || 'N/A',
      usedReferralCode || 'N/A',
      membership,
      status,
      timezone || '',
      expoToken || '',
      platform || '',
      disable ? 'Sí' : 'No',
      '', // Placeholder for "Tipo"
      pillars[0].emotions,
      pillars[0].relations,
      pillars[0].transformation,
      pillars[0].purpose,
      pillars[0].selfEsteem
    ];

    const emotionTitles = [
      'alegria',
      'ansiedad',
      'confianza',
      'enfado',
      'incomodidad',
      'miedo',
      'sorpresa'
    ];
    const consumptionData = emotionTitles.map((title) => {
      const record = emotions.find((e) => e.tag === title);
      return record
        ? record.total > 0
          ? ((record.points * 100) / record.total).toFixed(0)
          : 0
        : 0;
    });

    const pathsData = [];
    for (let index = 0; index < roadshistory.length; index++) {
      const road = roadshistory[index];
      pathsData.push(new Date(road.createdAt).toLocaleString());
      pathsData.push(road.road.name);
      pathsData.push(
        road.completed
          ? '100%'
          : `${(
              (road.currentEpisode / road.road.episodes.length) *
              100
            ).toFixed(0)}%`
      );
    }

    const singleRowArray = [...profileData, ...consumptionData, ...pathsData];
    console.log(singleRowArray);
    return singleRowArray;
  };

  const calculateColumnWidths = (data) => {
    const colWidths = data[0].map((_, colIndex) =>
      Math.max(
        ...data.map((row) => (
          row[colIndex] ? row[colIndex].toString().length : 0)
        )
      )
    );
    return colWidths.map((width) => ({ wch: width + 2 }));
  };

  const downloadXLSX = (data) => {
    if (!data) return;

    const filename = 'subliful_user_data.xlsx';

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    worksheet['!cols'] = calculateColumnWidths(data);
    workbook.SheetNames.push('UserData');
    workbook.Sheets['UserData'] = worksheet;
    const xlsbin = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'binary'
    });

    const buffer = new ArrayBuffer(xlsbin.length);
    const array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    const xlsblob = new Blob([buffer], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(xlsblob);

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.click();
  };

  const processAndDownloadXLSX = async () => {
    if (userDetailsLoading || userDetailsError) return;

    const userDetails = userDetailsData?.excelUserList || [];

    if (userDetails.length === 0) return;

    const userData = userDetails[0];

    const constTitle = [
      'Perfil del Usuario',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      'Puntos por Pilar',
      '',
      '',
      '',
      '',
      'Consumo por Emociones',
      '',
      '',
      '',
      '',
      '',
      '',
      'Historial de Caminos'
    ];
    const title = [
      'Nombre Completo',
      'Correo Electrónico',
      'Teléfono',
      'Código Telefónico',
      'País',
      'Género',
      'Registro Completo',
      'Código de Referencia',
      'Código de Referencia Usado',
      'Membresía',
      'Estado',
      'Zona Horaria',
      'Token Expo',
      'Plataforma',
      'Deshabilitado',
      'Tipo',
      'Emociones',
      'Relaciones',
      'Transformacion',
      'Sentido de la vida',
      'Amor Propio',
      'alegria',
      'ansiedad',
      'confianza',
      'enfado',
      'incomodidad',
      'miedo',
      'sorpresa'
    ];
    for (let index = 0; index < userData.roadshistory.length; index++) {
      title.push('Fecha');
      title.push('Nombre');
      title.push('Completado');
    }

    downloadXLSX([constTitle, title, generateSingleRowArray(userData)]);
  };

  useEffect(() => {
    if (userDetailsData) {
      processAndDownloadXLSX();
    }
  }, [userDetailsData]);

  return (
    <Button
      className="add-new-user"
      color="primary"
      onClick={() => {
        fetchUserDetails();
      }}
      style={{ padding: '6px 8px' }}
    >
      <MdOutlineDownload
        style={{ width: '24px', height: '24px', marginRight: '10px' }}
      />
      Descargar Data
    </Button>
  );
};

export default ExportToXLSXButton;
